<template>
  <a-select
    v-model:value="sentimentSelected"
    :getPopupContainer="(trigger) => trigger.parentNode"
    class="custom-select"
    mode="multiple"
    style="width: 100%"
    :options="sentimentOptions"
    @change="onSentimentSelect"
  >
  </a-select>
  <!-- <a-select class="detail-select" v-model:value="messageTypeSelected" mode="tags" style="width: 100%">
    <template #dropdownRender="{}">
      <a-checkbox-group
        class="checkbox-custom vertical"
        v-model:value="messageTypeSelected"
        name="checkboxgroup"
        :options="messageTypeOptions"
        @change="onChange"
      />
    </template>
  </a-select> -->
</template>

<script>
import { ref, onMounted } from 'vue';

const defaultSentimentSelected = ['positive', 'neutral', 'negative'];
const defaultSentimentOptions = [
  { label: 'Positive', value: 'positive' },
  { label: 'Neutral', value: 'neutral' },
  { label: 'Negative', value: 'negative' },
];

export default {
  emits: ['onChangeSentiment'],
  setup(props, { emit }) {
    const sentimentSelected = ref([...defaultSentimentSelected]);
    const sentimentOptions = defaultSentimentOptions;

    const onSentimentSelect = () => {
      emit('onChangeSentiment', sentimentSelected.value);
    };

    onMounted(() => {
      // init first time
      emit('onChangeSentiment', sentimentSelected.value);
    });

    return {
      onSentimentSelect,
      sentimentOptions,
      sentimentSelected,
    };
  },
};
</script>

<style lang="scss" scoped>
.custom-select {
  :deep(.ant-select-selector) {
    min-height: 42px;
    border: 1px solid #e3e6ef;
    border-radius: 4px;
  }

  :deep(.ant-select-selection-item) {
    background: rgba(240, 245, 255, 1);
    border-radius: 5px;
    color: rgba(90, 95, 125, 1);
  }
}
</style>
